export default [{
  path: '/documentos-e-licencas',
  component: {
    name: 'documentos-e-licencas',
    template: '<router-view />',
    meta: {
      resource: 'documentos-e-licencas',
      action: 'read',
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'documentos-e-licencas',
    component: () => import('@/app-modulo/comuns/documentos-e-licencas/DocumentoLicencasView.vue'),
    meta: {
      resource: 'documentolicenca',
      action: 'read',
      navActiveLink: 'documentos-e-licencas',
      pageTitle: 'Documentos e Licenças',
      breadcrumb: [
        {
          text: 'Documentos e Licenças',
          to: { name: 'documentos-e-licencas' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-documento-licenca',
    component: () => import('@/app-modulo/comuns/documentos-e-licencas/shared/components/cadastro/DocumentoLicenca.vue'),
    meta: {
      resource: 'documentolicenca',
      action: 'create',
      navActiveLink: 'documentos-e-licencas',
      pageTitle: 'Documentos e Licenças',
      breadcrumb: [
        {
          text: 'Documentos e Licenças',
          to: { name: 'documentos-e-licencas' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-documento-licenca' },
          active: true,
        },
      ],
    },
  },
  {
    path: ':id',
    name: 'ver-documento-licenca',
    component: () => import('@/app-modulo/comuns/documentos-e-licencas/shared/components/cadastro/DocumentoLicenca.vue'),
    meta: {
      resource: 'documentolicenca',
      action: 'read',
      navActiveLink: 'documentos-e-licencas',
      pageTitle: 'Documentos e Licenças',
      breadcrumb: [
        {
          text: 'Documentos e Licenças',
          to: { name: 'documentos-e-licencas' },
        },
        {
          text: 'Novo',
          to: { name: 'ver-documento-e-licenca' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar-observacao/:id',
    name: 'editar-observacao',
    component: () => import('@/app-modulo/comuns/documentos-e-licencas/shared/components/cadastro/DocumentoLicenca.vue'),
    meta: {
      resource: 'documentolicenca',
      action: 'read',
      navActiveLink: 'documentos-e-licencas',
      pageTitle: 'Cadastro de documentos e licenças',
      breadcrumb: [
        {
          text: 'Documentos e Licenças',
          to: { name: 'documentos-e-licencas' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-observacao' },
          active: true,
        },
      ],
    },
  }],
}]
